import bridge from '../core';

const apiName = 'springfesgoods';
/**
 * 调用原生springfesgoods方法
 * @param {JSON} data
 * @param {String} data.code 助力口令
 * @param {Number} data.id 商品id
 * @param {String} data.type '0'为原价购买，'1'是1元购买
 */

function fallback() {
    console.log('springfesgoods: 调用原生失败');
}

function back(data) {
    return {
        api: JSON.stringify(data),
        fallback
    };
}
bridge.register(apiName, back);
